import { handleHideModal, handleInputChange } from 'components/global/_helpers/global.helpers';
import SimpleModal from 'components/global/SimpleModal';
import UniversalInput from 'components/global/UniversalInput';
import { handleSubmitCreateTeam } from 'components/views/InvestorTeam/_helpers/investorTeam.events';
import { Col, Row } from 'react-bootstrap';
import { $form, $view } from 'signals/global.signals';

const InvestorTeamCreateModal = () => (
  <SimpleModal
    show={$view.value.activeModal === 'add-team'}
    onHide={handleHideModal}
    enforceFocus={false}
    title="Add Team"
    primaryButtonText="Save"
    onPrimaryClick={handleSubmitCreateTeam}
    secondaryButtonText="Cancel"
    onSecondaryClick={handleHideModal}
    isLoading={$view.value.isModalLoading}
  >
    <Row>
      <Col>
        <UniversalInput
          name="name"
          label="Team Name"
          className="mb-16"
        />
        <UniversalInput
          type="select"
          name="users"
          label="Users"
          value={$form.value.users}
          isMulti
          options={$view.value.userOptions}
          onChange={(selectedOptions) => {
            handleInputChange({ name: 'users', value: selectedOptions });
          }}
        />
      </Col>
    </Row>
  </SimpleModal>
);

export default InvestorTeamCreateModal;
